enum State {
    selected = 1,
    locked = 2,
    deleted = 4
}

export { State };
